/**
 * Google Sheets Integration Page
 * Admin page for managing Google Sheets integration
 */

import React from 'react';
import { AdminRoute } from '../../components/auth/AdminRoute';
import GoogleSheetsBackupDashboard from '../../components/googleSheets/GoogleSheetsBackupDashboard';

const GoogleSheetsPage = () => {
  return (
    <AdminRoute>
      <GoogleSheetsBackupDashboard />
    </AdminRoute>
  );
};

export default GoogleSheetsPage;
